import { i18n } from './initialize';

/**
 * The BCP 47 tag to hand `Intl` and `toLocaleString` so dates and numbers
 * follow the language the app is showing. The pseudo-locale has no
 * conventions of its own and formats as English, which keeps its output
 * readable while the text is pirate.
 */
export const formatLocale = (): string => {
  const language = i18n.resolvedLanguage || i18n.language || 'en';
  return language === 'en-PI' ? 'en' : language;
};
